import React, { useState } from 'react'
import Sidebar from '../sidebar/sidebar'
import Breadcrumb from '../../../core/common/Breadcrumb/breadcrumb';
import { all_routes } from '../../router/all_routes';
import { Link } from 'react-router-dom';
import ImageWithBasePath from '../../../core/common/imageWithBasePath';
import ReactApexChart from 'react-apexcharts';
import AgentDhashboardModal from './agentDhashboardModal';
import DashboardCard from '../../userDashboard/dashboard/components/DashboardCard';
import BookingsStatistics from './components/BookingsStatistics';
import RecentlyAdded from './components/RecentlyAdded';
import {t} from "../../../lang/index"

const AgentDashboard = () => {

  const routes = all_routes;
  //Breadcrumb Data
  const breadcrumbs = [
    {
      label: 'Agent Dashboard',
      active: false,
      link: routes.home1
    },
    {
      label: 'Agent Dashboard',
      active: true,
    },
  ];

  const [earningChart] = useState<any>({
    series: [
      {
        name: 'Income',
        data: [5000, 16000, 8000, 5000, 4000, 5000, 12000, 5000, 8000, 5000, 5000, 8000],
      },
      {
        name: 'Expenses',
        data: [5000, 4000, 4000, 5000, 8000, 5000, 4000, 5000, 4000, 5000, 5000, 4000],
      },
    ],
    options: {
      chart: {
        height: 280,
        type: 'bar',
        stacked: true,
        toolbar: {
          show: false,
        },
      },
      colors: ['#0E9384', '#E4EBF1'],
      responsive: [
        {
          breakpoint: 480,
          options: {
            legend: {
              position: 'bottom',
              offsetX: -10,
              offsetY: 0,
            },
          },
        },
      ],
      plotOptions: {
        bar: {
          borderRadius: 5,
          borderRadiusWhenStacked: 'all',
          horizontal: false,
          endingShape: 'rounded',
        },
      },
      xaxis: {
        categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        labels: {
          style: {
            colors: '#4E5561',
            fontSize: '12px',
          },
        },
      },
      yaxis: {
        labels: {
          formatter: (val: number) => {
            return val / 1000 + 'K';
          },
          offsetX: -15,
          style: {
            colors: '#4E5561',
            fontSize: '13px',
          },
        },
      },
      grid: {
        show: false,
      },
      legend: {
        show: false,
      },
      dataLabels: {
        enabled: false, // Disable data labels
      },
      fill: {
        opacity: 1,
      },
    },
  });

  return (
    <div>

      <Breadcrumb title="Agent Dashboard" breadcrumbs={breadcrumbs} backgroundClass="breadcrumb-bg-04" />

      {/* Page Wrapper */}
      <div className="content">
        <div className="container">
          <div className="row">
            {/* Sidebar */}
            <div className="col-xl-3 col-lg-4">
              <Sidebar />
            </div>
            {/* /Sidebar */}
            <div className="col-xl-9 col-lg-8">
              <div className="row">
                <DashboardCard
                  apiEndpoint="/empresas/dashboard/total-bookings"
                  icon="isax-calendar-15"
                  bgColor="bg-success"
                  label={t("dashboardCards.totalBookings")}
                  colClass="col-xl-3 col-sm-6 d-flex"
                />
                <DashboardCard
                  apiEndpoint="/empresas/dashboard/total-listings"
                  icon="isax-money-time5"
                  bgColor="bg-orange"
                  label={t("dashboardCards.totalListings")}
                  colClass="col-xl-3 col-sm-6 d-flex"
                />
                <DashboardCard
                  apiEndpoint="/empresas/dashboard/total-earnings"
                  icon="isax-money-send5"
                  bgColor="bg-info"
                  label={t("dashboardCards.totalEarnings")}
                  colClass="col-xl-3 col-sm-6 d-flex"
                />
                <DashboardCard
                  apiEndpoint="/empresas/dashboard/total-reviews"
                  icon="isax-magic-star5"
                  bgColor="bg-indigo"
                  label={t("dashboardCards.totalReviews")}
                  colClass="col-xl-3 col-sm-6 d-flex"
                />
              </div>
              <div className="row">
                {/* Bookings Statistics */}
                <BookingsStatistics />
                {/* /Bookings Statistics */}

                {/* Earnings */}
                <div className="col-xl-8 d-flex">
                  <div className="card shadow-none flex-fill">
                    <div className="card-body pb-0">
                      <div className="d-flex justify-content-between align-items-center mb-4">
                        <h6>Earnings</h6>
                        <div className="dropdown ">
                          <Link
                            to="#"
                            className="dropdown-toggle btn bg-light-200 btn-sm text-gray-6 rounded-pill fw-normal fs-14 d-inline-flex align-items-center"
                            data-bs-toggle="dropdown"
                          >
                            <i className="isax isax-calendar-2 me-2 fs-14 text-gray-6" />
                            2025
                          </Link>
                          <ul className="dropdown-menu  dropdown-menu-end p-3">
                            <li>
                              <Link
                                to="#"
                                className="dropdown-item rounded-1"
                              >
                                <i className="ti ti-point-filled me-1" />
                                2025
                              </Link>
                            </li>
                            <li>
                              <Link
                                to="#"
                                className="dropdown-item rounded-1"
                              >
                                <i className="ti ti-point-filled me-1" />
                                2024
                              </Link>
                            </li>
                            <li>
                              <Link
                                to="#"
                                className="dropdown-item rounded-1"
                              >
                                <i className="ti ti-point-filled me-1" />
                                2023
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="row">
                        <div className="d-flex align-items-center justify-content-between flex-wrap">
                          <div className="mb-2">
                            <p className="mb-0">Total Earnings this Year</p>
                            <h3>$20,659</h3>
                          </div>
                          <div className="d-flex align-items-center mb-2">
                            <p className="fs-14">
                              <span className="badge badge-soft-success badge-md border border-success rounded-pill me-2">
                                <i className="isax isax-arrow-up-3 " />
                                12%
                              </span>
                              vs last years
                            </p>
                          </div>
                        </div>
                        <div id="earning-chart">
                          <ReactApexChart
                            options={earningChart.options}
                            series={earningChart.series}
                            type="bar"
                            height={280}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /Earnings */}
              </div>
              <div className="row">
                {/* Recently Added */}
                <RecentlyAdded />
                {/* /Recently Added */}
                {/* Recent Invoices */}
                <div className="col-xxl-7 col-xl-6 d-flex">
                  <div className="card shadow-none flex-fill">
                    <div className="card-body">
                      <div className="d-flex justify-content-between align-items-center mb-4 gap-2">
                        <h6>Latest Invoices</h6>
                      </div>
                      <div className="card shadow-none mb-4">
                        <div className="card-body p-2">
                          <div className="d-flex justify-content-between align-items-center flex-fill">
                            <div>
                              <div className="d-flex align-items-center flex-wrap mb-1">
                                <Link
                                  to={routes.invoices}
                                  className="fs-14 link-primary border-end pe-2 me-2 mb-0"
                                >
                                  #INV12565
                                </Link>
                                <p className="fs-14">Date: 15 May 2024</p>
                              </div>
                              <h6 className="fs-16 fw-medium">
                                Cloudrider 789
                              </h6>
                            </div>
                            <div className="text-end">
                              <p className="fs-14 mb-1">Amount</p>
                              <h6 className="fw-medium">$569</h6>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="card shadow-none mb-4">
                        <div className="card-body p-2">
                          <div className="d-flex justify-content-between align-items-center flex-fill">
                            <div>
                              <div className="d-flex align-items-center flex-wrap mb-1">
                                <Link
                                  to={routes.invoices}
                                  className="fs-14 link-primary border-end pe-2 me-2 mb-0"
                                >
                                  #INV12564
                                </Link>
                                <p className="fs-14">Date: 13 May 2024</p>
                              </div>
                              <h6 className="fs-16 fw-medium">
                                <Link to={routes.hotelDetails}>The Luxe Haven</Link>
                              </h6>
                            </div>
                            <div className="text-end">
                              <p className="fs-14 mb-1">Amount</p>
                              <h6 className="fw-medium">$430</h6>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="card shadow-none mb-4">
                        <div className="card-body p-2">
                          <div className="d-flex justify-content-between align-items-center flex-fill">
                            <div>
                              <div className="d-flex align-items-center flex-wrap mb-1">
                                <Link
                                  to={routes.invoices}
                                  className="fs-14 link-primary border-end pe-2 me-2 mb-0"
                                >
                                  #INV12563
                                </Link>
                                <p className="fs-14">Date: 10 May 2024</p>
                              </div>
                              <h6 className="fs-16 fw-medium">
                                <Link to={routes.carDetails}>Ford Mustang 4.0 AT</Link>
                              </h6>
                            </div>
                            <div className="text-end">
                              <p className="fs-14 mb-1">Amount</p>
                              <h6 className="fw-medium">$380</h6>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="card shadow-none mb-0">
                        <div className="card-body p-2">
                          <div className="d-flex justify-content-between align-items-center flex-fill">
                            <div>
                              <h6 className="fs-16 fw-medium mb-1">
                                <Link to={routes.cruiseDetails}>Super Aquamarine</Link>
                              </h6>
                              <div className="d-flex align-items-center flex-wrap">
                                <Link
                                  to={routes.invoices}
                                  className="fs-14 link-primary border-end pe-2 me-2 mb-0"
                                >
                                  #INV12562
                                </Link>
                                <p className="fs-14">Date: 04 May 2024</p>
                              </div>
                            </div>
                            <div className="text-end">
                              <p className="fs-14 mb-1">Amount</p>
                              <h6 className="fw-medium">$475</h6>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /Recent Invoices */}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Page Wrapper */}
      <AgentDhashboardModal />

    </div>
  )
}

export default AgentDashboard
